import React, { useState, useEffect } from "react"
import './index.css';
import { Button, ButtonGroup, Modal, Form, Table } from "react-bootstrap";
import axios from 'axios';
import { connect } from "react-redux";
import NumericInput from 'react-numeric-input';
import store from "./store/index";
import { ORDER_API, ODD_API, getLoginToken, updateBetId, API_BF_FUND, getCurrencySymbol } from "./constants/utils";
import { UPDATE_DISPLAY_CONFIRM_NOX } from "./constants/action-types";

const BfPlaceBet = (props) => {

  const [show, setShow] = useState(false);
  const [odd, setOdd] = useState(props.runner.currentPrice);
  const [oddModified, setOddModified] = useState(false);
  const [stakeChanged, setStakeChanged] = useState(false);
  const [stake, setStake] = useState(0);
  const [oddInterval, setOddInterval] = useState(null);
  const [latestOdd, setLatestOdd] = useState({});
  const [selectedBetOption, setSelectedBetOption] = useState('NONE');
  const [selectedBetType, setSelectedBetType] = useState('BACK');
  const [currencySymbol, setCurrencySymbol] = useState('');

  const handleClose = () => {
    setShow(false);
    clearInterval(oddInterval);
  }
  const handleUpdateodd = (value) => {
    setOdd(value);
    setOddModified(true)
  }

  const handleUpdateStake = (value) => {
    setStake(value);
    setStakeChanged(true)
  }

  const getStake = () => {
    if (!stakeChanged) {
      return selectedBetType === 'BACK' ? Number(store.getState().latestOddsSettings.backStake) :
        Number(store.getState().latestOddsSettings.layStake)
    }
    return stake;
  }


  useEffect(() => {
    //if (!props.displayConfirmBox) {
      const intervalId2 = setInterval(getLatestOdds, 1000);
      return () => {
          clearInterval(intervalId2);
      }
   // }
  }, [props.displayConfirmBox, props.marketId,  props.betMarket]);


  const handleShow = () => {
    setShow(true);
    getLatestOdds();
    requestBfFundInfo();
    const intervalId2 = setInterval(getLatestOdds, 1000);
    setOddInterval(intervalId2)
  }

  const persistenceOptions = ['SP', 'NONE'];
  const actionOptions = ['BACK', 'LAY'];


  function findOddToDisplay() {
    //If user modified odd, dot overwrite it with latest odd
    //If latest odd is not fetched then use odd coming from parent.
    if (oddModified || !latestOdd) {
      return odd;
    }
    return selectedBetType === 'BACK' ? latestOdd.bestBackOdd : latestOdd.bestLayOdd;
  }

  function requestBfFundInfo() {
    const postRequestPara = {
      "ssoid": getLoginToken()
    }
    axios.post(API_BF_FUND, postRequestPara)
      .then((res) => {
        if (res?.data?.accountDetailsResponse?.currencyCode) {
          setCurrencySymbol(getCurrencySymbol(res.data.accountDetailsResponse.currencyCode))
        }
      },
        (error) => {
          console.log("error fetching account information.")
        });
  }

  function getLatestOdds() {
    const marketId = getMarketId();
    const selectionId = Number(props.runner.selectionId)
    if (marketId && selectionId) {
      const postRequestPara = {
        "requests":
          [{ "marketId": getMarketId(), "selectionId": selectionId }],
        "ssoid": getLoginToken(),
      }

      axios.post(ODD_API, postRequestPara)
        .then((res) => {
          //console.log("Result of ODD API ::" + res.data)
          const oddDetails = res.data
          if (oddDetails && oddDetails.length > 0) {
            setLatestOdd(oddDetails[0].runnerOdds[0])
          }
        },
          (error) => {
            //console.log("Result of API 3 returns Error!!!" + error)
          });
    }
  }
  const handleDirectOrder = (betType) => {
    placeBet(prepareNoConfirmRequest(betType, 'NONE'));
  }

  const prepareCconfirmRequest = () => {
    return {
      "ssoid": getLoginToken(),
      "marketId": getMarketId(),
      "selectionId": props.runner.selectionId,
      "requestOdd": findOddToDisplay(),
      "requestSize": getStake(),
      "action": selectedBetOption,
      "betType": selectedBetType
    }
  }

  const prepareNoConfirmRequest = (betType, betAction) => {
    return {
      "ssoid": getLoginToken(),
      "marketId": getMarketId(),
      "selectionId": props.runner.selectionId,
      "requestOdd": findOddToDisplay(),
      "requestSize": getStake(),
      "action": betAction,
      "betType": betType
    }
  }

  const handleSubmit = (event) => {
    placeBet(prepareCconfirmRequest());
  }


  const placeBet = (postRequestPara) => {
    axios.post(ORDER_API, postRequestPara)
      .then((res) => {
        const betId = res.data
        if (betId) {
          updateBetId(betId.toString())
        }
      },
        (error) => {
          //console.log('Error message notification clicked');
        });
    handleClose();
  }

  function getStep(value) {
    if (value < 5) {
      return 0.1;
    } else if (value < 20) {
      return 1;
    } else {
      return 5;
    }
  }

  const format = (number) => {
    return Math.round(number * 100) / 100;
  }

  const getTitle = (marketDetails) => {
    //console.log(marketDetails)
    return marketDetails['venue'] + " " +
      marketDetails['date'] + " " +
      marketDetails['time'] + " " +
      marketDetails['marketName'];
  }

  const getCommission = () => {
    try {
      return (100 - store.getState().latestOddsSettings.commision) / 100;
    } catch (e) {
      console.log("error fetching commission", e)
    }
    return 1;

  }

  function getMarketId(){
    return props.betMarket && props.betMarket.marketId ? props.betMarket.marketId : props.marketId;
  }


  const decimalPlace = (num) => {
    try {
      return (Math.round(num * 100) / 100).toFixed(2);
    } catch (error) {
      return "Fetching";
    }
  }

  const oddButtons = (
    <ButtonGroup aria-label="Basic example">
      <Button onClick={() => handleDirectOrder('BACK')} style={{ color: "black", backgroundColor: "rgba(166, 216, 255, 0.5)", margin:"0px", padding:"0px" }} >{latestOdd ? decimalPlace(latestOdd.bestBackOdd) : 'Fetching'}</Button>
      <Button onClick={() => handleDirectOrder('LAY')} style={{ color: "black", backgroundColor: "rgba(250, 201, 212, 0.5)", margin:"0px", padding:"0px" }}  >{latestOdd ? decimalPlace(latestOdd.bestLayOdd) : 'Fetching'}</Button>
    </ButtonGroup>
  );

  const placeBetModal = (
    <>
      {props.suspended ? <Button size="sm" onClick={handleShow} disabled> Suspended</Button> :
        props.displayConfirmBox ? <Button size="sm" onClick={handleShow} > Place Bet</Button> : oddButtons}
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{getTitle(props.marketName)}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "15px", margin: "5px", padding: "5px" }}>
          <Table style={{ width: "auto", marginBottom: "1px" }} striped bordered hover>
            <thead>
              <tr>
                <th></th>
                <th>Back</th>
                <th>Lay</th>
                <th>Volume</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{props.runner.name}</td>
                <td style={{ backgroundColor: "rgba(166,216,255,.5)" }} >{latestOdd ? latestOdd.bestBackOdd : null}</td>
                <td style={{ backgroundColor: "rgba(250,201,212,.5)" }}>{latestOdd ? latestOdd.bestLayOdd : null}</td>
                <td style={{ backgroundColor: "rgba(255,255,255,.5)" }}>{currencySymbol}{latestOdd ? latestOdd.volumeMatched : null}</td>
              </tr>
            </tbody>
          </Table>
          <form onSubmit={handleSubmit}>
            <Table style={{ width: "auto", marginBottom: "1px" }} striped bordered hover>
              <thead>
                <tr>
                  <th></th>
                  <th>Your Odds</th>
                  <th>Your Stake</th>
                  <th>P/L If Win</th>
                  <th>P/L If Lose</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{props.runner.name}</td>
                  <td><NumericInput min={1.0} onChange={(value) => handleUpdateodd(value)} step={getStep(odd)} precision={2} value={findOddToDisplay()} />
                  </td>
                  <td><NumericInput min={0} onChange={handleUpdateStake} step={getStep(stake)} precision={2} value={getStake()} />
                  </td>
                  <td>{selectedBetType === 'BACK' ? format((odd - 1) * getStake() * getCommission()) : format(getStake() * getCommission())}</td>
                  <td>{selectedBetType === 'BACK' ? format(getStake()) : format((odd - 1) * getStake())}</td>
                </tr>
              </tbody>
            </Table>
            <Table style={{ width: "auto", marginBottom: "1px" }} striped bordered hover>
              <thead>
                <tr>
                  <th>Persistence</th>
                  <th>Bet Type</th>

                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {persistenceOptions.map(type => (
                      <Form.Check
                        inline
                        label={type}
                        name="persistenceType"
                        type="radio"
                        value={type}
                        defaultChecked={type === selectedBetOption}
                        onChange={(e) => setSelectedBetOption(e.target.value)}
                        id={`persistence-${type}`}
                      />
                    ))}
                  </td>
                  <td>
                    {actionOptions.map(type => (
                      <Form.Check
                        inline
                        label={type}
                        value={type}
                        name="actionType"
                        type="radio"
                        defaultChecked={type === selectedBetType}
                        onChange={(e) => {
                          setSelectedBetType(e.target.value)
                        }
                        }
                        id={`action-${type}`}
                      />
                    ))}
                  </td>
                </tr>
              </tbody>
            </Table>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Place Bet
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
  return (
    <>
      {placeBetModal}
    </>
  )
}

const mapStateToProps = state => {
  return {
    displayConfirmBox: state.displayConfirmBox,
    betMarket: state.betMarket
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDisplayConfirmBox: payload =>
      dispatch({ type: UPDATE_DISPLAY_CONFIRM_NOX, payload: payload }),
      
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BfPlaceBet);
